import { Box } from "@mui/material";
import { useTu } from "@src/appV2/i18n/useTu";
import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/components/Text";
import { Title } from "@src/appV2/redesign/components/Title";
import { useOpenUrl } from "@src/mobile/utils/openUrl";
import { type ReactElement } from "react";

const I18N_SKIP_APP_STORE_URL = "https://apps.apple.com/us/app/clipboard-workers/id1472962791";
const I18N_SKIP_GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=health.clipboard.worker";

interface Props {
  onBackToLogin: () => void;
}

export function WorkerAppLoginError({ onBackToLogin }: Props): ReactElement {
  const { tu } = useTu("login");
  const openUrl = useOpenUrl();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: 5,
        width: "100%",
        textAlign: "center",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <Title bold component="h5">
          {tu("Use the Clipboard Worker app")}
        </Title>
        <Text variant="body1" role="alert" sx={{ color: "base.muted" }}>
          {tu(
            "This email belongs to a Clipboard Worker account, which can't access the Clipboard Workplace app. Download Clipboard - Workers to sign in and find shifts."
          )}
        </Text>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <Button
          fullWidth
          href={I18N_SKIP_APP_STORE_URL}
          size="large"
          variant="secondary"
          onClick={(event) => {
            event.preventDefault();
            void openUrl(I18N_SKIP_APP_STORE_URL);
          }}
        >
          {tu("Download on the App Store")}
        </Button>
        <Button
          fullWidth
          href={I18N_SKIP_GOOGLE_PLAY_URL}
          size="large"
          variant="secondary"
          onClick={(event) => {
            event.preventDefault();
            void openUrl(I18N_SKIP_GOOGLE_PLAY_URL);
          }}
        >
          {tu("Download on Google Play Store")}
        </Button>
      </Box>
      <Button size="large" variant="link" onClick={onBackToLogin}>
        {tu("Go back to login page")}
      </Button>
    </Box>
  );
}
